import React from 'react';
import styled from 'styled-components';
import { LoadingIndicator } from '../Common';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const SuspenseLoading = () => (
  <Wrapper>
    <LoadingIndicator spinning />
  </Wrapper>
);

export { SuspenseLoading };
